<template>
  <div class="h-100 main-menu">
    <sidebar-menu
      :menu="menu"
      @collapse="onCollapse"
      @item-expanded="itemExpanded"
      :enable-collapsing="getUserData.enable_menu_collapsing"
      class="side-menu"
      theme="white-theme"
    >
    </sidebar-menu>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { SidebarMenu } from '@/components/navigation/sidebar-menu/index';
import ItemSeparator from '@/components/navigation/sidebar-menu/components/ItemSeparator';
import NoOrganizationUnitsItem from '@/components/navigation/sidebar-menu/components/NoOrganizationUnitsItem';

export default {
  name: 'MainSideBarMenu',
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters([
      'getPlaces',
      'getPlaceName',
    ]),
    ...mapGetters('user', [
      'getUserData',
    ]),
    getProjectMenu() {
      let projectTree = [];
      if (this.getPlaces.length === 0) {
        projectTree.push({
          header: true,
          component: NoOrganizationUnitsItem,
          visibleOnCollapse: false,
        });
      } else {
        projectTree = this.treeify(this.getPlaces);
      }
      return projectTree;
    },
    menu() {
      return [
        ...this.getProjectMenu,
        {
          header: true,
          component: ItemSeparator,
          visibleOnCollapse: true,
        },
        {
          title: this.$_.capitalize(this.$t('favorite')),
          icon: 'favorite',
          href: '/',
        },
        {
          title: this.$_.capitalize(this.$t('devices')),
          icon: 'device',
          href: '/devices',
          hidden: !(this.getUserData
            && (this.getUserData.enable_devices || this.getUserData.superuser)
            && this.getUserData.show_devices),
        },
        {
          title: this.$_.capitalize(this.$t('change-project')),
          icon: 'project',
          href: '/change-project',
        },
        {
          title: this.$_.capitalize(this.$t('scenes')),
          icon: 'scene',
          href: '/scenes',
        },
        {
          title: this.$_.capitalize(this.$t('vizualizations')),
          icon: 'visualization',
          href: '/spaceplans',
        },
        {
          title: this.$_.capitalize(this.$t('charts-and-values')),
          icon: 'chart',
          href: '/logging',
        },
        {
          title: this.$_.capitalize(this.$t('menu-notifications')),
          icon: 'notification',
          href: '/notifications',
        },
        {
          title: this.$_.capitalize(this.$t('techsupport')),
          icon: 'support',
          href: '/helpdesk',
        },
      ];
    },
  },
  methods: {
    itemExpanded(id) {
    },
    onCollapse(collapsed) {
      this.$emit('collapse', collapsed);
    },
    treeify(list) {
      const treeList = [];
      const lookup = {};
      list.forEach((obj) => {
        lookup[obj.id] = {
          child: [],
        };
      });
      list.forEach((obj) => {
        const menuItem = {
          title: this.getPlaceName(obj.id),
          icon: obj.icon,
          href: { name: 'service-groups', params: { placeId: obj.id } },
          id: obj.id,
          class: `lvl-${obj.level + 1}`,
          ...lookup[obj.id],
        };
        if (obj.parentId != null) {
          lookup[obj.parentId].child.push(menuItem);
        } else {
          treeList.push(menuItem);
        }
      });
      return treeList;
    },
    away() {
    },
  },
  components: {
    SidebarMenu,
  },
};
</script>

<style scoped>

</style>
